import { accountInitial, accountTitle, listedAccounts } from "../domain/accounts";
import { useApp } from "../state/store";

export function WorkspaceMenu() {
  const app = useApp();
  const listed = listedAccounts(app.state.accounts ?? [], {
    topics: app.state.topics,
    tasks: app.state.tasks ?? [],
    snapshots: app.state.snapshots,
    postMetrics: app.state.postMetrics,
  });
  const current = listed.find((item) => item.id === app.accountId && item.platform === "小红书")
    ?? listed.find((item) => item.platform === "小红书")
    ?? listed[0];

  if (!current) return null;
  const label = accountTitle(current);

  return (
    <div className="workspace">
      <button
        type="button"
        className="workspace-trigger"
        aria-label={label}
        title={label}
        onClick={() => {
          if (current.id !== app.accountId) app.setAccount(current.id);
        }}
      >
        <span className="workspace-avatar" aria-hidden="true">{accountInitial(current.displayName)}</span>
        <span className="workspace-copy">
          <b>{current.displayName}</b>
          <small>{current.platform}</small>
        </span>
      </button>
    </div>
  );
}
